import React from 'react';
import './index.scss';
const Checkbox = ({onClick, checked}) => {
    return (
        <div className='form-check-box'>
           <div className="cbx-ct cbx-ct--deposit">
                <input
                className="inp-cbx inp-cbx--deposit"
                id="cbx"
                type="checkbox"
                checked={checked}
                style={{ display: "none" }}
                />
                <label className="cbx cbx--deposit" htmlFor="cbx" onClick={onClick} >
                <span>
  
                    <svg width="12px" height="10px" viewBox="0 0 12 10">
                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                    </svg>
                </span>
                <span className="text regular" style={{fontFamily: 'GothamPro'}}>
                    Я даю згоду на обробку та використання моїх персональних даних
                </span>
                </label>
            </div>
        </div>
    )
}

export default Checkbox;